import { useTranslation } from "react-i18next";
import { Flex, Title } from "@mantine/core";

import { Dashboard } from "../../components/Dashboard";

export interface DashboardPageProps {}
export const DashboardPage = ({}: DashboardPageProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Flex
                align="center"
                justify="space-between"
                mb="lg"
                pb="md"
                style={{
                    borderBottom: "1px solid transparent",
                }}
            >
                <Title order={3} style={{ fontWeight: 600 }}>
                    {t("dashboard")}
                </Title>
            </Flex>
            <Dashboard />
        </>
    );
};
